(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!window.drPenXCartDrawerReady) {
    window.drPenXCartDrawerReady = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-dx-drawer-show]');
      if (!trigger) return;
      const root = trigger.closest('[data-dx-cart-drawer-root]');
      if (!root) return;
      const state = trigger.dataset.dxDrawerShow;
      root.dataset.state = state;
      root.querySelectorAll('[data-dx-drawer-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.dxDrawerPanel !== state;
      });
      root.querySelector('[data-dx-drawer-panel]:not([hidden]) button, [data-dx-drawer-panel]:not([hidden]) a')?.focus();
    });

    document.addEventListener('drawer:afterShow', (event) => {
      if (event.target.id !== 'CartDrawer') return;
      const root = event.target.querySelector('[data-dx-cart-drawer-root]');
      if (!root) return;
      root.dataset.state = 'quick';
      root.querySelectorAll('[data-dx-drawer-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.dxDrawerPanel !== 'quick';
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drpenx-cart-v1"] && !Shopify.designMode) return;
  try {
    
  if (!window.drPenXCartTabsReady) {
    window.drPenXCartTabsReady = true;
    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-dx-cart-reco-tab]');
      if (!tab) return;
      const root = tab.closest('[data-dx-cart]');
      if (!root) return;
      const tabs = Array.from(root.querySelectorAll('[data-dx-cart-reco-tab]'));
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        const panel = root.querySelector(`#${item.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = !selected;
      });
    });

    const syncCartDiscountState = () => {
      document.querySelectorAll('[data-dx-cart] .dx-cart-discount').forEach((details) => {
        if (details.dataset.dxDefaultReady === 'true') return;
        details.open = false;
        details.dataset.dxDefaultReady = 'true';
      });
    };

    syncCartDiscountState();
    window.addEventListener('resize', syncCartDiscountState, { passive: true });
    new MutationObserver(syncCartDiscountState).observe(document.body, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drpenx-cartridges-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-dxcart-section]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const tabs = Array.from(root.querySelectorAll('[data-dxcart-family]'));
      const cards = Array.from(root.querySelectorAll('[data-dxcart-card]'));
      const label = root.querySelector('[data-dxcart-label]');
      const count = root.querySelector('[data-dxcart-count]');
      const status = root.querySelector('[data-dxcart-status]');
      const empty = root.querySelector('[data-dxcart-empty]');
      const apply = (family, writeHistory = true) => {
        const target = tabs.find((tab) => tab.dataset.dxcartFamily === family) || tabs[0];
        let visible = 0;
        cards.forEach((card) => {
          const show = target.dataset.dxcartFamily === 'all' || card.dataset.family === target.dataset.dxcartFamily;
          card.hidden = !show;
          if (show) visible += 1;
        });
        tabs.forEach((tab) => {
          const active = tab === target;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        if (label) label.textContent = target.dataset.label;
        if (count) count.textContent = String(visible);
        if (status) status.textContent = `${target.dataset.label}: ${visible}`;
        if (empty) empty.hidden = visible !== 0;
        if (writeHistory) {
          const url = new URL(window.location.href);
          if (target.dataset.dxcartFamily === 'all') url.searchParams.delete('family');
          else url.searchParams.set('family', target.dataset.dxcartFamily);
          url.searchParams.delete('sort_by');
          window.history.pushState({ family: target.dataset.dxcartFamily }, '', url);
        }
      };
      tabs.forEach((tab) => tab.addEventListener('click', () => apply(tab.dataset.dxcartFamily)));
      window.addEventListener('popstate', () => apply(new URL(window.location.href).searchParams.get('family') || 'all', false));
      apply(new URL(window.location.href).searchParams.get('family') || 'all', false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drpenx-concern-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-dxconcern-section]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const tabs = Array.from(root.querySelectorAll('[data-concern-handle]'));
      const sectionId = root.dataset.dxconcernSection;
      const setActive = (pathname) => {
        tabs.forEach((tab) => {
          const active = new URL(tab.href).pathname === pathname;
          tab.classList.toggle('is-active', active);
          if (active) tab.setAttribute('aria-current', 'page'); else tab.removeAttribute('aria-current');
        });
      };
      const load = async (href, writeHistory = true) => {
        const destination = new URL(href, window.location.origin);
        root.classList.add('is-loading');
        root.setAttribute('aria-busy', 'true');
        try {
          const sectionUrl = new URL(destination);
          sectionUrl.searchParams.set('section_id', sectionId);
          const response = await fetch(sectionUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('section');
          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const nextResults = documentFragment.querySelector('[data-dxconcern-results]');
          const currentResults = root.querySelector('[data-dxconcern-results]');
          if (!nextResults || !currentResults) throw new Error('results');
          currentResults.replaceWith(nextResults);
          const currentGuidance = root.querySelector('[data-dxconcern-guidance]');
          const nextGuidance = documentFragment.querySelector('[data-dxconcern-guidance]');
          if (currentGuidance && nextGuidance) currentGuidance.replaceWith(nextGuidance);
          else if (currentGuidance && !nextGuidance) currentGuidance.remove();
          else if (!currentGuidance && nextGuidance) root.querySelector('.dxconcern__shell')?.append(nextGuidance);
          setActive(destination.pathname);
          root.dataset.activeHandle = destination.pathname.split('/').filter(Boolean).pop() || 'shop-by-concern';
          if (writeHistory) window.history.pushState({ concern: root.dataset.activeHandle }, '', destination);
          const status = root.querySelector('[data-dxconcern-status]');
          if (status) status.textContent = root.querySelector('.dxconcern__results-head h2')?.textContent || '';
        } catch (error) {
          window.location.assign(destination);
          return;
        } finally {
          root.classList.remove('is-loading');
          root.removeAttribute('aria-busy');
        }
      };
      tabs.forEach((tab) => tab.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        load(tab.href);
      }));
      window.addEventListener('popstate', () => load(window.location.href, false));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drpenx-home-commerce-v4"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-dxh4-root]').forEach(function (root) {
      function tuneChatLayer() {
        var host = document.querySelector('shopify-chat');
        if (!host || !host.shadowRoot || host.shadowRoot.querySelector('[data-dxh4-chat-style]')) return;
        var style = document.createElement('style');
        style.setAttribute('data-dxh4-chat-style', '');
        style.textContent = '.activator-nudge--right{right:14px!important;bottom:14px!important}.activator{width:46px!important;min-width:46px!important;height:46px!important;padding:0!important;border-radius:999px!important;box-shadow:0 8px 24px rgba(25,20,22,.12)!important}.activator__label{display:none!important}@media(max-width:749px){.activator-nudge--right{right:10px!important;bottom:10px!important}.activator{width:44px!important;min-width:44px!important;height:44px!important}}';
        host.shadowRoot.appendChild(style);
      }

      tuneChatLayer();
      [600, 1600, 3200].forEach(function (delay) { window.setTimeout(tuneChatLayer, delay); });

      if (window.matchMedia('(max-width:749px)').matches) {
        root.querySelectorAll('.dxh4-guidance details').forEach(function (item) { item.removeAttribute('open'); });
      }

      root.querySelectorAll('[data-dxh4-intent]').forEach(function (button) {
        button.addEventListener('click', function () {
          var group = button.closest('.dxh4-intent');
          group.querySelectorAll('[data-dxh4-intent]').forEach(function (item) { item.classList.toggle('is-active', item === button); });
          group.querySelector('[data-dxh4-intent-title]').textContent = button.dataset.title;
          group.querySelector('[data-dxh4-intent-copy]').textContent = button.dataset.copy;
          var action = group.querySelector('[data-dxh4-intent-action]');
          action.href = button.dataset.url;
          action.childNodes[0].textContent = button.dataset.action + ' ';
        });
      });

      root.querySelectorAll('[data-dxh4-lens]').forEach(function (button) {
        button.addEventListener('click', function () {
          var finder = button.closest('.dxh4-finder');
          finder.querySelectorAll('[data-dxh4-lens]').forEach(function (item) { item.classList.toggle('is-active', item === button); });
          finder.querySelectorAll('[data-dxh4-product]').forEach(function (card) { card.classList.toggle('is-recommended', card.dataset.dxh4Product === button.dataset.dxh4Lens); });
          finder.querySelector('[data-dxh4-lens-title]').textContent = button.dataset.title;
          finder.querySelector('[data-dxh4-lens-copy]').textContent = button.dataset.copy;
          var image = finder.querySelector('[data-dxh4-lens-image]');
          image.src = button.dataset.image;
          image.alt = button.dataset.alt;
          var card = finder.querySelector('[data-dxh4-product="' + button.dataset.dxh4Lens + '"]');
          var target = finder.querySelector('[data-dxh4-lens-action]');
           var cardLink = card.querySelector('.dxh4-card__link');
           var cardCta = card.querySelector('.dxh4-card__cta');
           target.href = cardLink.href;
           target.childNodes[0].textContent = cardCta.childNodes[0].textContent;
        });
      });

      root.querySelectorAll('[data-dxh4-model]').forEach(function (button) {
        button.addEventListener('click', function () {
          var match = button.closest('.dxh4-match');
          match.querySelectorAll('[data-dxh4-model]').forEach(function (item) { item.classList.toggle('is-active', item === button); });
          match.querySelector('[data-dxh4-match-title]').textContent = button.dataset.title;
          match.querySelector('[data-dxh4-match-copy]').textContent = button.dataset.copy;
          match.querySelector('[data-dxh4-model-label]').textContent = button.dataset.dxh4Model;
          match.querySelector('[data-dxh4-match-action]').href = button.dataset.url;
          match.querySelector('[data-dxh4-match-product]').textContent = button.dataset.product;
          match.querySelector('[data-dxh4-match-price]').textContent = button.dataset.price;
          var image = match.querySelector('[data-dxh4-match-media] img');
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = button.dataset.image;
          image.alt = button.dataset.alt;
        });
      });

      root.querySelectorAll('[data-dxh4-video]').forEach(function (button) {
        button.addEventListener('click', function () {
          var article = button.closest('article');
          var video = button.querySelector('video');
          article.classList.add('is-playing');
          video.play();
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drpenx-microneedling-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-dxp-section]');
    if (!section || section.dataset.dxpReady === 'true') return;
    section.dataset.dxpReady = 'true';

    const tabs = Array.from(section.querySelectorAll('[data-dxp-family]'));
    const cards = Array.from(section.querySelectorAll('[data-dxp-card]'));
    const status = section.querySelector('[data-dxp-status]');
    const empty = section.querySelector('[data-dxp-empty]');
    const activeLabel = section.querySelector('[data-dxp-active-label]');
    const visibleCount = section.querySelector('[data-dxp-visible-count]');
    const labels = new Map(tabs.map((tab) => [tab.dataset.dxpFamily, tab.querySelector('.dxp__tab-label').textContent.trim()]));
    const resultsLabels = new Map(tabs.map((tab) => [tab.dataset.dxpFamily, tab.dataset.resultsLabel || tab.querySelector('.dxp__tab-label').textContent.trim()]));

    const setFamily = (family, updateHistory = true) => {
      const nextFamily = labels.has(family) ? family : 'all';
      tabs.forEach((tab) => {
        const active = tab.dataset.dxpFamily === nextFamily;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      let visible = 0;
      cards.forEach((card) => {
        const active = nextFamily === 'all' || card.dataset.family === nextFamily;
        card.hidden = !active;
        if (active) {
          visible += 1;
          const index = card.querySelector('[data-dxp-card-index]');
          if (index) index.textContent = String(visible).padStart(2, '0');
        }
      });

      empty.hidden = visible !== 0;
      activeLabel.textContent = resultsLabels.get(nextFamily);
      visibleCount.textContent = visible;
      status.textContent = `${visible} ${resultsLabels.get(nextFamily)}`;

      if (updateHistory) {
        const url = new URL(window.location.href);
        if (nextFamily === 'all') url.searchParams.delete('family');
        else url.searchParams.set('family', nextFamily);
        window.history.pushState({ family: nextFamily }, '', url);
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => setFamily(tab.dataset.dxpFamily));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let targetIndex = index;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') targetIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') targetIndex = (index + 1) % tabs.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = tabs.length - 1;
        tabs[targetIndex].focus();
        setFamily(tabs[targetIndex].dataset.dxpFamily);
      });
    });

    window.addEventListener('popstate', () => {
      const family = new URL(window.location.href).searchParams.get('family') || 'all';
      setFamily(family, false);
    });

    const initialUrl = new URL(window.location.href);
    if (initialUrl.searchParams.has('sort_by')) {
      initialUrl.searchParams.delete('sort_by');
      window.location.replace(initialUrl);
      return;
    }
    const initialFamily = initialUrl.searchParams.get('family') || section.dataset.dxpInitialFamily || 'all';
    setFamily(initialFamily, false);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drpenx-sale-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-dxoffer-section]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const tabs = Array.from(root.querySelectorAll('[data-dxoffer-family]'));
      const cards = Array.from(root.querySelectorAll('[data-dxoffer-card]'));
      const label = root.querySelector('[data-dxoffer-label]');
      const count = root.querySelector('[data-dxoffer-count]');
      const status = root.querySelector('[data-dxoffer-status]');
      const empty = root.querySelector('[data-dxoffer-empty]');
      const apply = (family, writeHistory = true) => {
        const target = tabs.find((tab) => tab.dataset.dxofferFamily === family) || tabs[0];
        let visible = 0;
        cards.forEach((card) => {
          const show = target.dataset.dxofferFamily === 'all' || card.dataset.family === target.dataset.dxofferFamily;
          card.hidden = !show;
          if (show) visible += 1;
        });
        tabs.forEach((tab) => { const active = tab === target; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
        if (label) label.textContent = target.dataset.label;
        if (count) count.textContent = String(visible);
        if (status) status.textContent = `${target.dataset.label}: ${visible}`;
        if (empty) empty.hidden = visible !== 0;
        if (writeHistory) {
          const url = new URL(window.location.href);
          if (target.dataset.dxofferFamily === 'all') url.searchParams.delete('family'); else url.searchParams.set('family', target.dataset.dxofferFamily);
          url.searchParams.delete('sort_by');
          window.history.pushState({ family: target.dataset.dxofferFamily }, '', url);
        }
      };
      tabs.forEach((tab) => tab.addEventListener('click', () => apply(tab.dataset.dxofferFamily)));
      window.addEventListener('popstate', () => apply(new URL(window.location.href).searchParams.get('family') || 'all', false));
      apply(new URL(window.location.href).searchParams.get('family') || 'all', false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drpenx-sale-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.dxsale');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const buttons = Array.from(root.querySelectorAll('[data-sale-segment]'));
    const count = root.querySelector('[data-sale-result-count]');
    const label = root.querySelector('[data-sale-result-label]');
    const applySegment = (segment) => {
      const cards = Array.from(document.querySelectorAll('[id$="__main-collection"] .card-grid > .product-card'));
      let visible = 0;
      cards.forEach((card) => {
        const vendor = card.querySelector('.product-card__top')?.textContent.trim().toLowerCase() || '';
        const onSale = Boolean(card.querySelector('.price--on-sale'));
        const match = onSale && (segment === 'all' || vendor.includes(segment));
        card.classList.toggle('dxsale-card-hidden', !match);
        if (match) visible += 1;
      });
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.saleSegment === segment)));
      if (count) count.textContent = String(visible);
      if (label) label.textContent = visible === 1 ? root.dataset.offerLabelSingle : root.dataset.offerLabel;
    };
    buttons.forEach((button) => button.addEventListener('click', () => applySegment(button.dataset.saleSegment)));
    const refresh = () => applySegment(root.querySelector('[data-sale-segment][aria-pressed="true"]')?.dataset.saleSegment || 'all');
    const observer = new MutationObserver(refresh);
    const connectGrid = () => {
      const grid = document.querySelector('[id$="__main-collection"] .card-grid');
      if (grid) {
        grid.id = 'dxsale-products';
        observer.observe(grid, { childList: true });
      }
      refresh();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', connectGrid, { once: true });
    } else {
      connectGrid();
    }
    window.addEventListener('load', refresh, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function syncDrpenxDecisionBridge(root = document) {
    const content = root.querySelector('.drpenx-pdp-content') || document.querySelector('.drpenx-pdp-content');
    if (!content) return;

    const productionBridge = document.querySelector('[data-drpenx-l2-entry="product-bridge"]');
    const fallbackBridge = document.querySelector('[data-drpenx-bridge-fallback]');
    let bridge = productionBridge || fallbackBridge;

    if (productionBridge && fallbackBridge && productionBridge !== fallbackBridge) {
      fallbackBridge.remove();
    }

    if (!bridge) {
      const template = document.querySelector('template[data-drpenx-decision-bridge-template]');
      bridge = template?.content?.firstElementChild?.cloneNode(true) || null;
    }

    if (!bridge) return;

    bridge.classList.add('drpenx-decision-bridge');
    content.before(bridge);
  }

  function syncDrpenxChat(attempt = 0) {
    const chat = document.querySelector('shopify-chat');
    const label = chat?.shadowRoot?.querySelector('.activator__label');

    if (!label) {
      if (attempt < 24) window.setTimeout(() => syncDrpenxChat(attempt + 1), 250);
      return;
    }

    label.hidden = window.matchMedia('(max-width: 749px)').matches;
  }

  function buildDrpenxGeoChapters(root = document) {
    const content = root.querySelector('.drpenx-pdp-content') || document.querySelector('.drpenx-pdp-content');

    if (!content || content.dataset.drxChaptersReady === 'true') return;

    const children = Array.from(content.children);
    const usesEditorialProductSystem = document.body.classList.contains('drpenx-product-design');
    let chapter;
    let chapterBody;

    children.forEach((child) => {
      const directHeading = /^H[1-3]$/.test(child.tagName) ? child : null;
      const nestedHeading = usesEditorialProductSystem && child.tagName === 'SECTION'
        ? Array.from(child.children).find((node) => /^H[1-3]$/.test(node.tagName))
        : null;
      const heading = directHeading || nestedHeading;

      if (heading) {
        chapter = document.createElement(usesEditorialProductSystem ? 'details' : 'section');
        chapter.className = 'drx-geo-chapter';
        chapterBody = document.createElement('div');
        chapterBody.className = 'drx-geo-chapter__body';
        if (nestedHeading && child.id) chapter.id = child.id;
        content.insertBefore(chapter, child);

        if (usesEditorialProductSystem) {
          const summary = document.createElement('summary');
          summary.append(heading);
          chapter.append(summary, chapterBody);
        } else {
          chapter.append(heading, chapterBody);
        }

        if (nestedHeading) {
          while (child.firstChild) chapterBody.append(child.firstChild);
          child.remove();
          chapter = null;
          chapterBody = null;
        }
      } else if (chapterBody) {
        chapterBody.append(child);
      }
    });

    content.dataset.drxChaptersReady = 'true';
  }

  function syncDrpenxProductLayout(root = document) {
    buildDrpenxGeoChapters(root);
    syncDrpenxDecisionBridge(root);
    syncDrpenxChat();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncDrpenxProductLayout());
  } else {
    syncDrpenxProductLayout();
  }

  window.addEventListener('resize', () => syncDrpenxProductLayout());
  document.addEventListener('shopify:section:load', (event) => syncDrpenxProductLayout(event.target));

  } catch(e) { console.error(e); }
})();
})();
